import { render, staticRenderFns } from "./menu_itest.vue?vue&type=template&id=40f26a94&"
import script from "./menu_itest.vue?vue&type=script&lang=js&"
export * from "./menu_itest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports